import ApplicationController from './application_controller'

export default class extends ApplicationController {

  finalize(event) {
    event.stopPropagation()
    $(event.currentTarget).attr('disabled', true).text("Finalized")
    this.stimulate('AttendanceEvent#finalize') 
  }
}